import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { JSConn } from "@/utilities/js-conn";
import { format } from "date-fns";
import { map as Rmap } from "ramda";

export default {
  name: "finishWorkOrderTaskForm",
  components: {
    FormErrors,
    LoadingAnimation,
  },
  props: {
    workOrderTaskId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Task...Get the quantities ready...",
      hasFormErrors: false,
      formErrors: [],
      workOrderTask: {},
      workOrderTaskLineItems: [],
    };
  },
  methods: {
    submitData: function(evt) {
      evt.preventDefault();
      const jsConnWorkOrderTask = new JSConn();

      jsConnWorkOrderTask.formParams = {
        id: this.workOrderTask.id,
        status: this.workOrderTask.status,
        start_date: this.workOrderTask.start_date,
        completed_date: this.workOrderTask.completed_date,
      };

      let jsConnTaskLineItems = Rmap(item => {
        const tempJsConn = new JSConn();
        tempJsConn.formParams = {
          id: item.id,
          quantity: item.quantity,
          item_date: this.workOrderTask.completed_date,
        };
        return this.$store.dispatch("updateWorkOrderTaskLineItem", tempJsConn);
      }, this.workOrderTaskLineItems);

      const dataPromises = [
        this.$store.dispatch("completeWorkOrderTask", jsConnWorkOrderTask),
        ...jsConnTaskLineItems,
      ];

      Promise.all(dataPromises)
        .then(() => {
          this.$router.push({
            name: "workOrderNotes",
            params: { workOrderId: this.workOrderTask.work_order_id },
          });
          return Promise.resolve();
        })
        .catch(() => {
          return Promise.reject();
        });
    },
  },
  computed: {
    apiWorkOrderTask: function() {
      return this.$store.getters.workOrderTask;
    },
    apiWorkOrderTaskLineItems: function() {
      return this.$store.getters.workOrderTaskLineItems;
    },
  },
  created() {
    const jsConn = new JSConn();
    const jsConnTaskLineItems = new JSConn();
    // task params
    jsConn.formParams = {
      id: this.workOrderTaskId,
    };

    // task line item params params
    jsConnTaskLineItems.formParams = {
      work_order_task_id: this.workOrderTaskId,
    };

    const dataPromises = [
      this.$store.dispatch("needWorkOrderTask", jsConn),
      this.$store.dispatch("needWorkOrderTaskLineItems", jsConnTaskLineItems),
    ];

    Promise.all(dataPromises).then(() => {
      this.dataLoaded = true;
      // load the task into the form
      this.workOrderTask = {
        ...this.apiWorkOrderTask,
      };

      // set some of the data
      // since this form is being loaded, assume
      // that the job is completed and that it was completed today
      const td = format(new Date(), "yyyy-MM-dd");
      if (this.workOrderTask.start_date === null) {
        this.workOrderTask.start_date = td;
      }
      this.workOrderTask.completed_date = td;
      this.workOrderTask.status = "completed";

      // load the line items
      this.workOrderTaskLineItems = Rmap(item => {
        return {
          ...item,
          item_date: td,
          quantity: item.suggested_quantity,
          rate: item.line_item_default_rate,
        };
      }, this.apiWorkOrderTaskLineItems);
    });
  },
};
